import {
  View,
  Text,
  Image,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
} from "react-native";
import { useEffect, useState } from "react";
import React from "react";
import { useLocalSearchParams, useRouter } from "expo-router"; // Use this to access route params

import db, { storage } from "../Firestore/FirestoreConfig";
import { ref, getDownloadURL } from "firebase/storage";

import {
  query,
  where,
  collection,
  getDocs,
  setDoc,
  doc,
} from "firebase/firestore";
import CoachingApplication, {
  ApplicationQuestion,
  ApplicationSection,
} from "../Firestore/CoachingApplication";

import { v4 as uuidv4 } from "uuid";

import { observer, Observer } from "mobx-react";
import { useScreenDimensions, useDevice } from "../_layout";
import Colors from "../../Resources/Color";
import { TextInput, ActivityIndicator } from "react-native-web";
// import "../../Localization/i18next";
import { useTranslation } from "react-i18next";
import CustomAlert from "../Components/CustomAlert";

import { Ionicons } from "@expo/vector-icons";
import Fonts from "../../Resources/Fonts";
import CustomActivityIndicator from "../Components/CustomActivityIndicator";

export default function CoachDirectoryPage() {
  const { screenSize } = useScreenDimensions();
  const { t, i18n } = useTranslation();

  const router = useRouter();
  const { coachApplications } = useLocalSearchParams(); // Access the dynamic parameter
  const coachDirectory = coachApplications?.toLowerCase(); // Get the coach directory from the route parameter
  const { isMobile } = useDevice();

  // let applicationForm = null;
  const [applicationForm, setApplicationForm] = useState(null); // State for CoachingApplication
  const [coachName, setCoachName] = useState("");
  const [coachSurname, setCoachSurname] = useState("");
  const [coachId, setCoachId] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);
  const [logoAspectRatio, setLogoAspectRatio] = useState(null);

  const [showingClearForm, setShowingClearForm] = useState(false);
  const clearFormTitle = "clearFormAlertTitle-string";
  const clearFormText = "clearFormAlertText-string";

  const [applicationSent, setApplicationSent] = useState(false);

  const adjustedHeight = screenSize === "large" ? 70 : 50;
  const adjustedWidth = adjustedHeight / logoAspectRatio;

  const [showingErrorRequiredFields, setShowingErrorRequiredFields] =
    useState(false);

  const fetchApplicationForm = (formData) => {
    const newApplicationForm = new CoachingApplication(
      uuidv4(),
      coachDirectory,
      formData.description,
      null
    );
    formData.sections.forEach((sectionData) => {
      const newSection = new ApplicationSection(
        sectionData.id,
        sectionData.name,
        sectionData.order,
        [], // Questions will be populated next
        applicationForm // Link the section to the form
      );

      // Handle the questions array within each section
      sectionData.questions.forEach((questionData) => {
        const newQuestion = new ApplicationQuestion(
          questionData.id,
          questionData.question,
          questionData.is_required,
          questionData.answer,
          questionData.order,
          newSection // Link the question to the section
        );

        newSection.questions.push(newQuestion); // Add the question to the section
      });

      newApplicationForm.sections.push(newSection); // Add the section to the form
    });

    setApplicationForm(newApplicationForm);
  };

  useEffect(() => {
    const fetchDocument = async () => {
      if (!coachDirectory) return;

      try {
        const formCollectionRef = collection(db, "coaching_application_forms");
        const formQuery = query(
          formCollectionRef,
          where("directory", "==", coachDirectory)
        );

        const querySnapshot = await getDocs(formQuery);

        if (!querySnapshot.empty) {
          querySnapshot.forEach((doc) => {
            fetchApplicationForm(doc.data());
            // applicationForm.fetchInit(doc.data());

            setCoachName(doc.data().coach_name);
            setCoachSurname(doc.data().coach_surname);
            setCoachId(doc.data().coach_id);
            i18n.changeLanguage(doc.data().coach_language ?? "en");
            // You can handle the fetched document here, e.g., set it in state or pass it to a function.
          });
        } else {
          console.log(
            "No such document with the specified directory!, ",
            coachDirectory
          );
          router.replace("/"); // Redirect if the document does not exist
        }
      } catch (error) {
        console.error("Error fetching document:", error);
        router.replace("/"); // Redirect if there is an error
      }
    };

    fetchDocument();
  }, [coachDirectory, router]);

  useEffect(() => {
    const fetchLogo = async () => {
      if (!coachId) return;

      try {
        const storageRef = ref(storage, `coach_logos/${coachId}`);
        const url = await getDownloadURL(storageRef);

        setLogoUrl(url);

        const img = new window.Image();
        img.src = url;
        img.onload = () => {
          setLogoAspectRatio(img.height / img.width);
        };
      } catch (error) {
        console.log("Logo not found for coach:", coachId, error);
        // Logo doesn't exist, keep logoUrl as null
        setLogoUrl(null);
        setLogoAspectRatio(null);
      }
    };

    if (applicationForm) {
      applicationForm.setProperty("coachId", coachId);
    }

    fetchLogo();
  }, [coachId]);

  const ImageComponent = ({ logoUrl }) => {
    return (
      logoUrl && (
        <Image
          source={{ uri: logoUrl }}
          style={{
            width: adjustedWidth,
            height: adjustedHeight,
            marginBottom: screenSize === "small" ? 30 : 50,
            borderRadius: 12,
          }}
        />
      )
    );
  };

  const RequiredSectionBlock = observer(() => {
    const RequiredQuestionRow = observer(({ question, idx }) => {
      const isRequired = idx === 1 ? false : true;
      const [isHovered, setIsHovered] = useState(false);

      return (
        question && (
          <View
            style={{
              width: "100%",
              borderColor: "gray",
              borderRadius: 10,
              // paddingLeft: 8,
              marginTop: idx !== 0 ? 10 : 0,
            }}
          >
            <Text
              style={{
                fontSize: screenSize === "large" ? 14 : 12,
                marginBottom: 10,
                marginLeft: 5,
              }}
            >
              {t(question)}
              {isRequired && (
                <Text
                  style={{
                    color: Colors.redColor,
                    fontSize: screenSize === "large" ? 14 : 12,
                  }}
                >
                  *
                </Text>
              )}
            </Text>

            {/* <Text
              style={[
                styles.answerInputStyle,
                { fontSize: screenSize === "large" ? 14 : 12 },
              ]}
            >
              {question.answer}
            </Text> */}

            <TextInput
              style={[
                styles.answerInputStyle,
                {
                  fontSize: screenSize === "large" ? 14 : 12,
                  borderColor: isHovered
                    ? "rgba(0, 0, 0, 0.5)"
                    : Colors.borderColor,
                },
              ]}
              placeholder={t("yourAnswer-string")}
              placeholderTextColor={Colors.grayColor}
              value={
                idx === 0
                  ? applicationForm.clientName
                  : idx === 1
                  ? applicationForm.clientSurname
                  : applicationForm.clientEmail
              }
              onChangeText={(text) =>
                applicationForm.setProperty(
                  idx === 0
                    ? "clientName"
                    : idx === 1
                    ? "clientSurname"
                    : "clientEmail",
                  text
                )
              }
              multiline={true}
              numberOfLines={screenSize === "large" ? 2 : 3}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            />
          </View>
        )
      );
    });

    return (
      <View
        style={{
          marginBottom: 15,
          width: "100%",
        }}
      >
        {/* {idx !== 0 && <View style={styles.sectionSeparator} />} */}
        <Text
          style={[
            styles.sectionNameStyle,
            { fontSize: screenSize === "large" ? 14 : 12 },
          ]}
        >
          {t("requiredInfo-string")}
        </Text>

        <View
          style={{
            width: "100%",
            alignItems: "center",
            backgroundColor: Colors.whiteColor,
            borderRadius: 20,
            padding: 16,
            borderWidth: 0.1,
            borderColor: Colors.borderColor,
          }}
        >
          <RequiredQuestionRow question={"name-string"} idx={0} />
          <RequiredQuestionRow question={"surname-string"} idx={1} />
          <RequiredQuestionRow question={"email-string"} idx={2} />
        </View>
      </View>
    );
  });

  const SectionBlock = observer(({ section }) => {
    const QuestionRow = observer(({ question, idx }) => {
      const [isHovered, setIsHovered] = useState(false);

      return (
        question && (
          <View
            style={{
              width: "100%",
              borderColor: "gray",
              borderRadius: 5,
              // paddingLeft: 8,
              marginTop: idx !== 0 ? 10 : 0,
            }}
          >
            <Text
              style={{
                fontSize: screenSize === "large" ? 14 : 12,
                marginBottom: 10,
                marginLeft: 5,
              }}
            >
              {t(question.question)}
              {question.isRequired && (
                <Text
                  style={{
                    color: Colors.redColor,
                    fontSize: screenSize === "large" ? 14 : 12,
                  }}
                >
                  *
                </Text>
              )}
            </Text>

            {/* <Text
              style={[
                styles.answerInputStyle,
                { fontSize: screenSize === "large" ? 14 : 12 },
              ]}
            >
              {question.answer}
            </Text> */}

            <TextInput
              style={[
                styles.answerInputStyle,
                {
                  fontSize: screenSize === "large" ? 14 : 12,
                  borderColor: isHovered
                    ? "rgba(0, 0, 0, 0.5)"
                    : Colors.borderColor,
                },
              ]}
              placeholder={t("yourAnswer-string")}
              placeholderTextColor={Colors.grayColor}
              value={question.answer}
              onChangeText={(text) => question.setProperty("answer", text)}
              multiline={true}
              numberOfLines={screenSize === "large" ? 2 : 3}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            />
          </View>
        )
      );
    });
    return (
      <View
        style={{
          marginBottom: 15,
          width: "100%",
        }}
      >
        {/* {idx !== 0 && <View style={styles.sectionSeparator} />} */}
        {/* <View style={styles.sectionSeparator} /> */}
        <Text
          style={[
            styles.sectionNameStyle,
            { fontSize: screenSize === "large" ? 14 : 12 },
          ]}
        >
          {section.name}
        </Text>

        <View
          style={{
            width: "100%",
            alignItems: "center",
            backgroundColor: Colors.whiteColor,
            borderRadius: 20,
            padding: 16,
            borderWidth: 0.1,
            borderColor: Colors.borderColor,
          }}
        >
          {section.questions &&
            section.questions.map((question, index) => (
              <QuestionRow question={question} idx={index} key={index} />
            ))}
        </View>
      </View>
    );
  });

  const Buttons = observer(({ form }) => {
    const [isLoading, setIsLoading] = useState(false);

    const Save = async () => {
      if (form.canSubmit) {
        setIsLoading(true); // Show loading indicator
        setShowingErrorRequiredFields(false);
        try {
          const formData = form.uploadToCloud(); // Get the form data to upload

          // Add the document to "answered_coaching_applications" collection
          // await addDoc(
          //   collection(db, "answered_coaching_applications"),
          //   formData
          // );

          const formDocRef = doc(
            db,
            "answered_coaching_applications",
            form.id.toLowerCase()
          );

          await setDoc(formDocRef, formData);

          console.log("Form successfully submitted!");
          setApplicationSent(true); // Indicate that the application was sent
        } catch (error) {
          console.error("Error submitting the form: ", error);
        } finally {
          setIsLoading(false); // Hide loading indicator
        }
      } else {
        setShowingErrorRequiredFields(true);
      }
    };

    const Button = ({ bool }) => {
      const [isHovered, setIsHovered] = useState(false);
      return bool ? (
        <TouchableOpacity
          onPress={Save}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              // marginHorizontal: 20,
              backgroundColor: Colors.bubbleColor,
              borderRadius: 14,
              borderWidth: 1,
              justifyContent: "center",
              borderColor: Colors.bubbleColor,
              // paddingVertical: 12,
              // paddingHorizontal: 16,
              width: 80,
              height: 40,
              justifyContent: "center",
              alignItems: "center",
              opacity: isHovered && !isLoading ? 0.7 : 1,
            }}
          >
            {isLoading ? (
              <CustomActivityIndicator large={false} white={true} />
            ) : (
              <Text
                style={{
                  textAlignVertical: "center",
                  textAlign: "center",
                  color: Colors.whiteColor,
                }}
              >
                {t("submit-string")}
              </Text>
            )}
          </View>
        </TouchableOpacity>
      ) : (
        <TouchableOpacity
          onPress={() => setShowingClearForm(true)}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              // backgroundColor: Colors.backgroundColor,
              justifyContent: "center",
              // paddingVertical: 12,
              // paddingHorizontal: 16,
              width: 80,
              height: 40,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text
              style={{
                textAlignVertical: "center",
                textAlign: "center",
                color: Colors.bubbleColor,
                fontWeight: isHovered ? "500" : "normal",
              }}
            >
              {t("clear-string")}
            </Text>
          </View>
        </TouchableOpacity>
      );
    };

    return (
      <View
        style={{
          width: "100%",
          flexDirection: "row",
        }}
      >
        <Button bool={false} />
        <View style={{ flex: 1 }} />
        <Button bool={true} />
      </View>
    );
  });

  const ApplicationSentView = () => {
    return (
      <View
        style={{
          alignSelf: "center",
          justifyContent: "center",
          backgroundColor: Colors.backgroundColor,
          flex: 1,
          width: "100%",
        }}
      >
        <View
          style={{
            alignSelf: "center",
            justifyContent: "center",
            backgroundColor: Colors.backgroundColor,
            flex: 1,
            width:
              screenSize === "large"
                ? "50%"
                : screenSize === "medium"
                ? "80%"
                : "95%",
            padding: 16,
          }}
        >
          <View
            style={{
              alignItems: "center",
              width: "100%",
              height: 80,
              justifyContent: "center",
            }}
          >
            <View
              style={{
                width: 64,
                height: 64,
                borderRadius: 32,
                backgroundColor: Colors.bubbleColor,
                opacity: 0.06,
                position: "absolute",
              }}
            />
            <View
              style={{
                width: 48,
                height: 48,
                borderRadius: 24,
                backgroundColor: Colors.bubbleColor,
                opacity: 0.08,
                justifyContent: "center",
                alignItems: "center",
                alignSelf: "center",
                position: "absolute",
              }}
            />
            <View
              style={{
                width: 48,
                height: 48,
                borderRadius: 24,
                alignItems: "center",
                justifyContent: "center",
                alignSelf: "center",
                position: "absolute",
              }}
            >
              <Ionicons
                name="document-text"
                size={24}
                color={Colors.bubbleColor}
              />
            </View>
          </View>
          <View
            style={{
              alignItems: "center",
              width: "100%",
              height: 100,
              justifyContent: "center",
            }}
          >
            <Text
              style={[
                screenSize === "small" ? Fonts.medium16 : Fonts.medium16,
                {
                  textAlign: "center",
                  color: Colors.blackColor,
                  // marginTop: 32,
                },
              ]}
            >
              {t("applicationSentTitle-string")}
            </Text>

            <Text
              style={[
                screenSize === "small" ? Fonts.regular14 : Fonts.regular14,
                {
                  textAlign: "center",
                  color: Colors.grayColor,
                  marginTop: 8,
                },
              ]}
            >
              {t("applicationSentText-string", {
                coachName: coachName != "" ? coachName : "Coach",
              })}
            </Text>
          </View>
        </View>
      </View>
    );
  };

  return applicationSent ? (
    <ApplicationSentView />
  ) : (
    <>
      {applicationForm ? (
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            alignItems: "center",
            paddingVertical: screenSize === "small" ? 30 : 50,
            backgroundColor: Colors.backgroundColor,
          }}
        >
          <ImageComponent logoUrl={logoUrl} />

          <View
            style={{
              width:
                screenSize === "large"
                  ? "50%"
                  : screenSize === "medium"
                  ? "80%"
                  : "95%",
              alignItems: "center",
              maxWidth: 800,
              minWidth: screenSize === "large" && 650,
            }}
          >
            <RequiredSectionBlock />
            {applicationForm.sections.map((section, idx) => (
              <SectionBlock section={section} key={idx} />
            ))}
            {showingErrorRequiredFields && (
              <Text
                style={{
                  color: Colors.redColor,
                  marginBottom: 16,
                  marginHorizontal: 16,
                  alignSelf: "center",
                  maxWidth: "100%",
                }}
              >
                {t("requiredFieldsNotFilled-string")}
              </Text>
            )}
            <Buttons form={applicationForm} />
          </View>

          {showingClearForm && (
            <CustomAlert
              isVisible={showingClearForm}
              onClose={() => setShowingClearForm(false)}
              title={clearFormTitle}
              text={clearFormText}
              action={() => applicationForm.clearForm()}
              specialCTA="clear-string"
            />
          )}
        </ScrollView>
      ) : (
        <CustomActivityIndicator large={false} white={true} />
      )}
    </>
  );
}

const styles = StyleSheet.create({
  sectionSeparator: {
    width: "95%",
    backgroundColor: "rgba(0,0,0,0.1)",
    height: 1,
    alignSelf: "center",
    marginBottom: 15,
  },
  sectionNameStyle: {
    width: "100%",
    color: Colors.blackColor,
    // paddingVertical: 4,
    marginBottom: 8,
    fontWeight: "600",
    marginLeft: 16,
  },
  answerInputStyle: {
    width: "100%",
    borderColor: Colors.borderColor,
    backgroundColor: Colors.whiteColor,
    color: Colors.blackColor,
    borderWidth: 0.1,
    padding: 8,
    borderRadius: 10,
    outlineStyle: "none",
  },
});
